module.exports = __webpack_public_path__ + "img/ericson.e6e0fe68.png";